export const getScrollableContainerElement = () => {
  return document.body;
};

export const scrollableContainerScrollToTop = () => {
  window.scrollTo(0, 0);
};
